import { Component } from '@angular/core';

import { CowTableComponent } from '../cow-table/cow-table.component';

@Component({
  selector: 'measurements-overview',
  templateUrl: './measurements-overview.component.html',
  imports: [CowTableComponent],
})
export class MeasurementsOverviewComponent {
  public selectedDate: Date = new Date();
}
